import SuperCard from './SuperCard';

const OngoingSuperCapstone = ({ data }: { data: any }) => {
  const getTasksDoneStr = (cap: any): string => {
    const totalTasks = cap.superCapstoneId.tasks.length || 0;
    let total_quiz_done = 0;

    for (const quiz of cap.quiz!) {
      if (quiz.percentage >= 40) {
        total_quiz_done += 1;
      }
    }

    const tasks_quizes_done: number =
      total_quiz_done + (cap.tasks?.length || 0);

    // Since 1 task + 1 quiz = 1 capstone task
    const totalTasksDone = Math.floor(tasks_quizes_done / 2);
    return `${totalTasksDone}/${totalTasks}`;
  };

  const getCapProgress = (cap: any): number => {
    const totalTasks = cap.superCapstoneId.tasks.length || 0;
    let total_quiz_done = 0;

    for (const quiz of cap.quiz!) {
      if (quiz.percentage >= 40) {
        total_quiz_done += 1;
      }
    }

    const total_tasks_done = cap.tasks?.length || 0;

    const perc =
      100 * ((total_tasks_done + total_quiz_done) / (2 * totalTasks));

    return perc;
  };

  const getDayCount = (cap: any): number => {
    const olderDate = new Date(cap.createdAt);
    const currentDate = new Date();

    const timeDifference = currentDate.getTime() - olderDate.getTime();
    const daysPassed = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    return daysPassed;
  };

  const getButtonText = (cap: any): string => {
    let total_quiz_done = 0;

    for (const quiz of cap.quiz!) {
      if (quiz.percentage >= 40) {
        total_quiz_done += 1;
      }
    }

    const total_tasks_done = cap.tasks?.length || 0;

    const totalFullTaskDone = Math.floor(
      (total_tasks_done + total_quiz_done) / 2
    );

    return `Continue Task ${totalFullTaskDone + 1}`;
  };

  return (
    <div className='space-y-4'>
      {data?.map((cap: any, idx: number) => (
        <SuperCard
          key={cap.superCapstoneId._id}
          _id={cap.superCapstoneId._id}
          title={cap?.superCapstoneId?.title}
          level={cap?.superCapstoneId?.level}
          logo={cap.superCapstoneId?.companyId?.logoUrl}
          country={cap.superCapstoneId?.companyId?.country}
          industry={cap.superCapstoneId?.companyId?.industryId?.title}
          skills={cap?.superCapstoneId?.skillId}
          domain={cap.superCapstoneId?.domainId?.title}
          tasks={cap.superCapstoneId?.tasks || []}
          capstoneSubmissions={cap?.capstoneSubmissions || null}
          createdAt={cap?.superCapstoneId?.createdAt}
          capstoneAssessments={cap?.capstoneAssessments || null}
          buttonText={getButtonText(cap)}
          capStatus='ongoing'
          buttonData={{
            date: new Date(cap.createdAt),
            dayCount: getDayCount(cap),
            progress: getCapProgress(cap),
            tasksDoneStr: getTasksDoneStr(cap),
          }}
        />
      ))}
    </div>
  );
};

export default OngoingSuperCapstone;
